import { JsActionApi } from './JsActionApi'
import { processingApi } from '@/api/processingApi'
import { GraphqQlApi } from '@/api/api.js'
import { signalRApi } from '@/api/signalR'
import { notificationApi } from '@/api/notificationApi'
import { getEdsApiInstance } from '../../api/edsApi'
import { getQrCodeApiInstance } from '../../api/qrCodeApi'
import axios from '../../plugins/axios'
import moment from 'moment'
import momentDuration from 'moment-duration-format' 
import { getJsActionsRunner } from './getJsActionsRunner'

export default {
  install(Vue, options) {
    let { dependencies } = options

    dependencies.GraphqQlApi = GraphqQlApi
    dependencies.Moment = moment
    dependencies.MomentDuration = momentDuration
    dependencies.SignalRApi = signalRApi
    dependencies.NotificationApi = notificationApi
    dependencies.ProcessingApi = processingApi
    dependencies.Axios = axios
    dependencies.RouterCore = Vue.$routerCore
    dependencies.DataSourceCore = Vue.$dataSourceCore
    dependencies.$t = function(key) { return dependencies.i18n.t(key) }
    dependencies.$microflowRunner = Vue.$microFlowRunner
    dependencies.getEdsApi = getEdsApiInstance
    dependencies.getQrCodeApi = getQrCodeApiInstance
    let jsActionsApiInstance = new JsActionApi(dependencies)

    getJsActionsRunner(Vue, jsActionsApiInstance, processingApi)
  }
}